import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../js/coreRuntime.mjs';
import { KClass1cc9rfeybg8hs as KClass } from '../../KClassJs.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../js/void.mjs';
import { UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException } from '../../../exceptions.mjs';
import { jsIsType3jt51kzl8sm7y as jsIsType } from '../../../js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KClassImplClass;
function KClassImpl() {
  if (KClassImplClass === VOID) {
    class $ {
      equals(other) {
        var tmp;
        if (other instanceof NothingKClassImpl()) {
          tmp = false;
        } else {
          if (other instanceof KClassImpl()) {
            tmp = equals(this.ef(), other.ef());
          } else {
            tmp = false;
          }
        }
        return tmp;
      }
      hashCode() {
        var tmp0_safe_receiver = this.ff();
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
        return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      }
      toString() {
        return 'class ' + this.ff();
      }
    }
    initMetadataForClass($, 'KClassImpl', VOID, VOID, [KClass()]);
    KClassImplClass = $;
  }
  return KClassImplClass;
}
var NothingKClassImplClass;
function NothingKClassImpl() {
  if (NothingKClassImplClass === VOID) {
    class $ extends KClassImpl() {
      constructor() {
        NothingKClassImpl_instance = null;
        super();
        NothingKClassImpl_instance = this;
        this.hf_1 = 'Nothing';
      }
      ff() {
        return this.hf_1;
      }
      gf(value) {
        return false;
      }
      ef() {
        throw UnsupportedOperationException().i5("There's no native JS class for Nothing type");
      }
      equals(other) {
        return other === this;
      }
      hashCode() {
        return 0;
      }
    }
    initMetadataForObject($, 'NothingKClassImpl');
    NothingKClassImplClass = $;
  }
  return NothingKClassImplClass;
}
var NothingKClassImpl_instance;
function NothingKClassImpl_getInstance() {
  if (NothingKClassImpl_instance === VOID)
    new (NothingKClassImpl())();
  return NothingKClassImpl_instance;
}
var PrimitiveKClassImplClass;
function PrimitiveKClassImpl() {
  if (PrimitiveKClassImplClass === VOID) {
    class $ extends KClassImpl() {
      constructor(jClass, givenSimpleName, isInstanceFunction) {
        super();
        this.if_1 = jClass;
        this.jf_1 = givenSimpleName;
        this.kf_1 = isInstanceFunction;
      }
      ef() {
        return this.if_1;
      }
      equals(other) {
        if (!(other instanceof PrimitiveKClassImpl()))
          return false;
        return super.equals(other) && this.jf_1 === other.jf_1;
      }
      ff() {
        return this.jf_1;
      }
      gf(value) {
        return this.kf_1(value);
      }
    }
    initMetadataForClass($, 'PrimitiveKClassImpl');
    PrimitiveKClassImplClass = $;
  }
  return PrimitiveKClassImplClass;
}
var SimpleKClassImplClass;
function SimpleKClassImpl() {
  if (SimpleKClassImplClass === VOID) {
    class $ extends KClassImpl() {
      constructor(jClass) {
        super();
        this.lf_1 = jClass;
        var tmp = this;
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_safe_receiver = this.lf_1.$metadata$;
        // Inline function 'kotlin.js.unsafeCast' call
        tmp.mf_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.simpleName;
      }
      ef() {
        return this.lf_1;
      }
      ff() {
        return this.mf_1;
      }
      gf(value) {
        return jsIsType(value, this.lf_1);
      }
    }
    initMetadataForClass($, 'SimpleKClassImpl');
    SimpleKClassImplClass = $;
  }
  return SimpleKClassImplClass;
}
//region block: exports
export {
  NothingKClassImpl_getInstance as NothingKClassImpl_getInstance1v9lrhbzi4zr5,
  KClassImpl as KClassImpl3o7kfo8v13fhm,
  PrimitiveKClassImpl as PrimitiveKClassImpl1fv46nzfav2pd,
  SimpleKClassImpl as SimpleKClassImpl1arbnmvef0y44,
};
//endregion

//# sourceMappingURL=KClassImpl.mjs.map
